import React from "react";
import {
  Faq,
  Hero,
  Howitworks,
  Quote,
  Whatweoffer,
  Whychooseus,
} from "./Sections";
import styled from "styled-components";

const Root = styled.section`
  width: 100%;
`;

export const Home = () => {
  return (
    <Root>
      <Hero />
      <Whatweoffer />
      <Howitworks />
      <Whychooseus />
      <Quote />
      <Faq />
    </Root>
  );
};
